export const JUNIPER_CRITERIA = {
  JUNIPER: [
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Hardware Price Available?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Outsourcing",
      Questions: "Price per site Tier Available?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Licensing (# users, bandwidth, length of time, fixed)",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Hardware Availability",
      Model: "All",
      Questions: "How available is the necessary hardware? (Lead times)",
      Check: "Yes",
      Rating: 1,
      Notes: "4-6 Weeks",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How is path selection determined? (jitter, latency, packet loss)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Session Smart Router (SSR) provides path monitoring using Bi-directional Forwarding Detection (BFD) and Inline Flow Performance Measurement (IFPM) are techniques. The information collected on each path to influence session routing is packet loss, latency, jitter, and MOS statistics.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path selection be dynamically configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "What path selection options can be set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Session Smart Router (SSR) can route based different dynamic or user defined applications using a unique application specific policy based on learned packet loss, latency, jitter, or upstream dynamic routing changes (e.g. BGP or OSPF route changes).",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Can traffic be tagged based on rules?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic be prioritized based on QOS or traffic tags?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path load sharing be configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic steering be configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution utilize traffic shaping to prioritize traffic for critical applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution automatically select the best transport layer path based on performance metrics?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can the solution offer automated network failover?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution optimize access to popular SaaS applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there AI features for path selection?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Does solution detect and respond to a link-layer brownout? How?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can solution detect and respond to an application brownout? How? ",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe the system's link selection capabilities. Are they available per application?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution monitor application reachability across multiple links?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe how the solution handles end-user connections (TCP flows) when traffic has to be moved from one link to another. Are sessions terminated or maintained?",
      Check: "Yes",
      Rating: 3,
      Notes: "Maintained",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution maintain flow symmetry and correct flows when asymmetry is detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Session-aware architecture ensures bidirectional path symmetry. Dynamically recalculates paths to align flows within the same session.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "Can the solution support all types of WAN transport layer connection types?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "All transport layer technologies are supported? Which ones are not?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions: "Are Dynamic Protocols supported? Please list.",
      Check: "Yes",
      Rating: 1,
      Notes: "BGP and OSPF",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "Does the solution operate without restrictions to any protocols?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there any routing best practices for the product? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, https://www.juniper.net/documentation/us/en/software/mist/mist-wan/topics/concept/wan-assurance-design-overview.html",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Outsourcing",
      Questions:
        "Can the Client control routes at the edge in the MSP scenario?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can the solution support multiple circuit carriers in active/active connection setup?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Can routing be controlled at the edge?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does solution not require data-plane traffic to transit through single or multiple POPs (Point of Presence). Does solution operate without remote GW requirement?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "How does the solution integrate natively with existing MPLS WAN networks? Can the overlay and underlay be used simultaneously?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions: "Does the solution offer redundancy options (specify)? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Juniper Mist WAN Assurance solution leverages the Mist cloud, which is a highly available cloud service built using microservices that support the orchestration, management, and monitoring operations of the solution. In addition to the highly available Mist cloud, managed devices can be deployed as a high-availability (HA) pair in active/active mode and leverage HA technologies such as Virtual Router and Redundancy Protocol (VRRP) and Link Aggregation Groups (LAGs). If desired, some platforms also support dual power supplies for increased availability.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is there no requirement for additional equipment besides the redundant SD-WAN appliance?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "All redundancy and failover features are available in the SSR base software license.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Outsourcing",
      Questions: "What are failover and recovery speeds?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The SSR supports both link and site/cluster scenarios for fast failover within milliseconds.  Paths between two SSR nodes are selected for initial session routing in compliance with the desired SLA or using lowest latency or load balancing algorithms.  When the desired SLA changes during the session (or complete link failure is detected), the session may be re-routed across a new path by retransmitting the Secure Vector Routing metadata via new the new path and using new a peer waypoint address (or addresses).  Upon receipt of metadata matching an existing session ID, the receiving SSR will merge the session in both directions, ensuring bi-directional traffic is resumed within milliseconds.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution include HA capabilities without requiring additional licensing? If not, please describe the licensing structure.",
      Check: "No",
      Rating: 1,
      Notes: "Additional licensing for HA appliance throughput",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution work without WAN-side switches and/or unique ISP addresses?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support fail-to-wire interfaces (multi-networking failover interfaces)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can and how does the solution operate when it is unable to communicate with its controller or orchestration function (if any)?",
      Check: "Yes",
      Rating: 3,
      Notes: "Operates independently using locally stored policies and routes.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support link capacity monitoring without flooding the link?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution maintain 100% of the WAN capacity in the event of a unit failure?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions: "Are there no geographic deployment restrictions?",
      Check: "No",
      Rating: 1,
      Notes: "Iran, Russia, North Korea, Angola, etc.",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions:
        "What is the experience utilizing the solution in countries like China?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "The Juniper WAN Assurance solution is deployed in global customer footprints without any issues. As the SSR leverages Secure Vector Routing (SVR) instead of IPsec for router to router secure connections, deployments are also successful within China for global footprints. More details on how SVR works can be found here: https://www.juniper.net/content/dam/www/assets/white-papers/us/en/routers/session-smart-routing-how-it-works.pdf",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Is solution documentation access available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Are training options available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer Zero Touch Provisioning?  If so, please describe the process.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper's WAN Assurance solution with the Session Smart Router (SSR) fully supports Zero Touch Provisioning (ZTP) and can be used to provision new Juniper devices in your network automatically, with minimal manual intervention. You can use either management ports, a 4G interface, or network ports, depending on your device, to connect to the network. ",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If ZTP is offered, does it operate without special DNS/DHCP records?",
      Check: "Yes",
      Rating: 3,
      Notes: "No custom DHCP options or DNS records are required.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions:
        "Does the solution offer integration with Legacy Infrastructures?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there a templating feature? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Juniper Mist WAN Assurance solution leverages either WAN Edge or Hub Profile Templates as defined and assigned to devices managed through the solution. WAN Edge templates are assigned to spoke devices while Hub Profile templates are assigned to hub devices at the data center. Each site can have only one template assigned but does allow for site-specific overwrites to what would otherwise be configured through the applied template. Templates allow for bulk provisioning of the wan edge routers at various sites and enabled a standardized configuration. However, the ability to override at a device level at a site is available as well to enable flexibility in cases where the site CPE has some differences from the standard templates.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions: "How many hours does a new site turn-up normally take?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "A site turnup can take as little as 10 minutes to ZTP a Session Smart Router via Mist.  The repetitive process and management via Mist allows customer to scale deployment and some large enterprise customers have deployed between 20-30 branches per night with proper planning and coordination of field resources. ",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no node limitations or restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "In general there are no Session Smart Router node limitations or restrictions. Typically it is as easy as understanding how much bandwidth a site is required and purchase the hardware that will meet these requirements. The SSR100 and SSR1000 series datasheets can be found here for more information:\r\nhttps://www.juniper.net/content/dam/www/assets/datasheets/us/en/routers/ssr100-line-of-routers-datasheet.pdf\r\nhttps://www.juniper.net/content/dam/www/assets/datasheets/us/en/routers/ssr1000-line-of-routers-datasheet.pdf",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no tunnel limitations or bandwidth?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The SSR100 and SSR1000 series datasheets contain the maximum bandwidth for each platform. The number of tunnel or overlay paths can be provided and ranges from 120-16000 depending on the system.\r\nhttps://www.juniper.net/content/dam/www/assets/datasheets/us/en/routers/ssr100-line-of-routers-datasheet.pdf\r\nhttps://www.juniper.net/content/dam/www/assets/datasheets/us/en/routers/ssr1000-line-of-routers-datasheet.pdf",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there no limitations on logical WAN interfaces? If so, please describe ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "No limitations on the number of WAN interfaces the SSR software can support.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "No deployment architecture options and limitations? (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes: "Cloud, On Prem, Hub and Spoke, Limited mesh",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution support hub and spoke VPN topologies? Are multiple hubs supported?  (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper’s SSR supports hub and spoke architectures with multiple hubs, providing session-aware routing and failover.",
    },
    {
      Criteria: "Scalability",
      Model: "Outsourcing",
      Questions:
        "If managed hardware solution, can the circuits be brought into existing hardware?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions:
        "Describe the steps for migrating a hybrid WAN (MPLS primary, Internet backup) solution into a SDWAN? Are there no disruptiions?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "No other scalability limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper would be happy to review a planned design based on your scalability concerns. In general, Session Smart Routers use Secure Vector Router (SVR) instead of IPsec for secure router to router traffic allowing higher throughput and more overlays connections compared to other SD-WAN competitors. ",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer a Single Pane of Glass?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution allow management through the SSL portal? If yes does it support MFA and AD integration? SAML/SSO?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer performance visibility?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the solution support Third-Party Application Integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does solution not require an Engineer to Node?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Outside of the initial physical racking and stacking of Juniper SSRs, all other functions can be done remotely via the centralized Mist cloud portal. These functions done remotely includes: ZTP, deployment troubleshooting, post-deployment troubleshooting, firmware upgrades, any configuration changes, remote support access (when needed), and remote user CLI access.",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer API integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the API provide access to 100% of the features and functions of the solution?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is the solution's management platform self-hosted, or vendor provided?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Mist cloud is provided by Juniper across a global cloud footprint.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If vendor-provided, what underlying platform is being used (GCP/AWS/Azure/etc.)? What's the support model? Are there no regional limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "No regional limitations as the Mist cloud is hosted in both AWS and GCP in these regions: US, CA, EU, AU, and FedRamp. In addition, Juniper maintains distribution locations worldwide (North America, Taiwan, Europe and Japan - with Australia).",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If not vendor-provided, how is it deployed/managed? How does it scale?",
      Check: "Yes",
      Rating: 3,
      Notes: "Juniper deploys and maintains the Mist cloud.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Ease of Use? (new employee turn-up, vendor-specific terminology)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper MIST provides training, guidance, bootcamps, and support to help individuals and organizations get the most out of the tool. The training options offered by Juniper include instructor-led courses, virtual classrooms, online self-paced learning, and certification programs. The guidance and support provided by Juniper include documentation, online resources, and a dedicated support team to assist with any questions or issues. Overall, Juniper MIST provides comprehensive support to help individuals and organizations get up and running quickly and effectively, and stay ahead of the demands of modern networks.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Describe the upgrade process required to upgrade the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cloud-Driven Upgrades via Mist AI. Upgrades are managed through the Mist Cloud platform, leveraging AI-driven automation. The Mist AI system schedules and deploys updates to all connected devices, ensuring minimal downtime. Devices can be updated in groups or individually, with a rollback option if issues arise. The process is seamless, requiring minimal manual intervention.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there generative AI capabilities for management?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "What is the licensing model for the solution? Please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Session Smart Router (SSR) licensing is very simple per site based on the following 3 factors:\r\n-Expected bandwidth\r\n-How many year(s) term\r\n-Feature sets (only 3 options to chose from!)",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the solution have an automation feature set?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer integration with other troubleshooting projects?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution support live packet capture for troubleshooting purposes?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Mist AI-enabled SD-WAN solutions support live packet capture via the Mist Cloud platform, allowing administrators to analyze traffic directly from managed devices. This feature is integrated with Mist’s AI-driven diagnostics for faster troubleshooting.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the management solution support inline ticket creation?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Mist AI supports inline ticket creation through its cloud-based management interface. Administrators can log and track issues directly within the Mist platform, integrated with AI-driven troubleshooting for rapid resolution.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Can network administrator use the solution to troubleshoot an end-user specific reported application performance problem?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Are there any native testing tools available for troubleshooting? If so, what are they?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Juniper Mist WAN Assurance solution has a wide range of Analytics dashboards and reports to meet the requirements of diverse IT stakeholders.\r\n1) WAN Service Level Experiences (SLEs) dashboard for user experience metrics and WAN health up to 7 days.\r\nGet operational visibility into user WAN experiences with SLEs for Session Smart Routers or SRX Series Services Gateways. Measure the impact of both gateway and WAN circuit health on enduser application experiences. A WAN Link Health SLE, which accounts for network congestion, cable issues, and ISP network availability, delivers insights into how these factors are affecting a given network user or application. The Juniper Mist SLE dashboard helps to identify root causes of suboptimal application experiences in just a few clicks and proactively isolate “needle-in-ahaystack” problems.\r\n\r\n2) Marvis Actions view for proactive Fault Monitoring on WAN networks\r\nMarvis Virtual Network Assistant moves IT operations closer to the Self-Driving Network™ with simplified troubleshooting and performance analysis for helpdesk staff and network administrators. Simply ask a question in natural language and get actionable insights. Marvis brings proactive anomaly detection into the SLE dashboard, so you’re alerted to deviations from established baselines. And with Marvis Actions, you’ll get proactive recommendations for WAN issues such as MTU mismatch, bad cables, and WAN link congestion and outages.\r\n-The Marvis Conversational Interface service allows IT teams to quickly get answers to questions like, “Why is my user’s video chat application experience bad?” The Juniper Mist Temporal Entity Relationship Framework correlates WAN, LAN, and WLAN network entities to provide you with the exact root cause(s) of a degraded application experience. Marvis Actions then provides recommendations to improve those experiences.\r\n-Conversational AI – Troubleshooting Application\r\n-Marvis Actions proactively detecting WAN link issues\r\n\r\n3) WAN Insights page for 7 days Site level analytics\r\nKnow exactly how Session Smart Routers are performing with metrics and insights down to the port level. These include CPU, memory utilization, bytes transferred, traffic utilization, and power draw. WAN Assurance also logs gateway events, like configuration changes and system alerts. WAN and IPsec utilization insights tell you how much traffic traverses your encrypted tunnel versus your local breakout. You also get visibility into per-user and per-application performance and experiences.\r\n\r\n4) Premium Analytics Reports for long term analytics (13 Months) and trends of traffic, applications, and link performances.\r\nJuniper Mist Premium Analytics Service gives end-to-end network visibility and unique, data-driven insights and customized reports for Wi-Fi, Wired, and WAN networks. The WAN dashboard data for up to 13 months and generates performance and trending insights for WAN link performance, traffic and Applications. Each of the dashboards can be customized to run for entire Org, Site, SSR or WAN links. Email scheduling and downloading is supported with various formats.\r\n\r\n5) Advanced Troubleshooting tools such as session packet capture, dynamic packet capture, speed test, application connection test, and direct CLI access are also available.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer Artificial Intelligence capabilities? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Mist AI uses a combination of artificial intelligence, machine learning, and data science techniques to optimize user experiences and simplify operations across the wireless access, wired access, and SD-WAN domains.\r\nData is ingested from numerous sources, including Juniper Networks Access Points, switches, and gateways for end-to-end insight into user experiences. These devices work in concert with Mist AI to optimize user experiences from client-to-cloud, including automated event correlation, root cause identification, Self-Driving Network™ operations, network assurance, proactive anomaly detection, and more.\r\nJuniper also leverages Mist AI for next-generation customer support. It is the foundational element behind Marvis, the industry’s first AI-driven Virtual Network Assistant, which provides extensive insight and guidance to IT staff via a natural language conversational interface.\r\nThe Mist AI overview, including links to its specifications and technical documentation, can be found at http://www.juniper.net/us/en/products/mist-ai.html.\r\nFor purposes of clarity, all referenced Juniper Hardware or Software must be purchased and/or licensed separately.",
    },
    {
      Criteria: "Technical Support",
      Model: "All",
      Questions:
        "Does the solution offer 24/7 technical support with defined service levels for response and resolution time? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes - Response Time Service Levels are defined in the JTAC User Guide https://www.juniper.net/content/dam/www/assets/resource-guides/us/en/jtac-user-guide.pdf and we have Customer centric service add-ons to enhance targeted resolution times.",
    },
    {
      Criteria: "Technical Support",
      Model: "Insourcing/Co-Managed",
      Questions: "Is solution training available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions:
        "How long is an estimated MTTR of a defective gateway appliance (what are support options)?",
      Check: "Yes",
      Rating: 3,
      Notes: "",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "What are the SLA support options available, list.",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "Are there financial implications for breaching SLA, explain?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are reporting capabilities available? Describe.",
      Check: "Yes",
      Rating: 3,
      Notes: "",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "What types of data can be reported?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "In general the Mist AI cloud ingests the 1,000s of raw metric from the Session Smart Routers (SSRs) and leverages AI to find any user affecting issue. There are specific use cases were direct SSR data is required and can be provided as well. All of this data can be provided via the Mist UI or via webhooks/APIs as needed.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can KPI data baselines be calculated automatically?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there network-wide insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the WAN Service Level Experiences (SLEs) can be rolled up to an enterprise wide view for a single view into how an entire enterprise is operating. A typical use case as to why this is valuable is to find the top 5 poorest performing sites that have user impact to isolate and resolve those issues. For longer term planning purposes this data can be available as well using Premium Analytics.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there site-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, WAN Service Level Experiences (SLEs) and WAN Insights are available at a site level.\r\n\r\n1) WAN Service Level Experiences (SLEs) dashboard for user experience metrics and WAN health up to 7 days.\r\nGet operational visibility into user WAN experiences with SLEs for Session Smart Routers. Measure the impact of both gateway and WAN circuit health on enduser application experiences. A WAN Link Health SLE, which accounts for network congestion, cable issues, and ISP network availability, delivers insights into how these factors are affecting a given network user or application. The Juniper Mist SLE dashboard helps to identify root causes of suboptimal application experiences in just a few clicks and proactively isolate “needle-in-ahaystack” problems.\r\n\r\n2) WAN Insights page for 7 days Site level analytics\r\nKnow exactly how Session Smart Routers are performing with metrics and insights down to the port level. These include CPU, memory utilization, bytes transferred, traffic utilization, and power draw. WAN Assurance also logs gateway events, like configuration changes and system alerts. WAN and IPsec utilization insights tell you how much traffic traverses your encrypted tunnel versus your local breakout. You also get visibility into per-user and per-application performance and experiences.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there device-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, WAN Service Level Experiences (SLEs) specifically look at WAN edge device statistics and find any user impacting issues for the following classifiers:\r\n-Temperature\r\n-Memory\r\n-CPU\r\n-Power\r\n-SSR Connectivity\r\nIn addition, WAN insights are available to know exactly how Session Smart Routers are performing with metrics and insights down to the port level. These include CPU, memory utilization, bytes transferred, traffic utilization, and power draw.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are there link-level performance metrics available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Mist AI provides detailed link-level performance metrics, including latency, jitter, packet loss, and throughput, directly in its dashboard. These metrics are monitored in real time and visualized for easy analysis.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there application-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, WAN Service Level Experiences (SLEs) specifically look at application level statistics from session details and find any user impacting issues for the following classifiers:\r\n-Slow application\r\n-Application disconnects\r\n-Application bandwidth",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are performance metrics available for sub-applications (e.g. Gmail vs. all Google apps)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are full performance monitoring capabilities available for traffic using direct-to-internet paths?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there end-user insights available? If so, please describe.",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, insights are available all the way down to the client level. As you add more Juniper full stack Mist Managed products closer to the user, the more insights will be provided. With the SSR only, client details are available such as what applications are being used by what users are available in addition to being able to isolate all the way down to a user or groups of users that may be having WAN edge issues affecting their user experience.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Can the data be reported in a visually appealing format? (Graphs, illustrations, etc.)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can data reporting be filtered by different time frames?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Is this solution application-aware?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can traffic be dynamically steered based on real-time network performance and application priority?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application bandwidth be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application latency be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application jitter be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application loss be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can the solution throttle at the application level (similar to application-based QoS policy)?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Can policies be built based on tagged traffic?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer granular security policies?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there an application policy enforcement feature?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer monitoring and policy control based on user identity and user group membership?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution incorporate DLP mechanisms?",
      Check: "Yes",
      Rating: 2,
      Notes: "Yes, in combination with Juniper's Secure Edge solution.",
    },
    {
      Criteria: "Security Policy",
      Model: "All",
      Questions: "Does the solution allows login based on SSO?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Does the solution offer protection for the SD-WAN edge devices? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper's WAN Assurance solution with the Session Smart Router (SSR) protects applications and infrastructure against data loss and malicious attacks. Inherent security capabilities include deny-all (zero trust) routing, Layer 3/4 access control protection, and NAT and VPN functionality. The solution leverages a secure, tunnel-less approach using Secure Vector Routing (SVR), which provides strong data security without the overhead of traditional encryption protocols like IPsec. Using SVR, the solution reduces protocol overhead by over 30% when compared to IPsec. The solution provides the ability to detect, block, alarm, and log session denials for traffic that matches known IDP signatures. Any detected events will raise an associated Syslog, Security Audit Log, or Session Log message that can be forwarded to the appropriate support team. The Session-Smart Router solution provides complete L2/L3/L4 session-aware capabilities through a standard ICSA Certified firewall, eliminating the need for standalone firewalls. IDP and URL filtering are additional features that can be enabled on a per application basis to match security compliance requirements. As an alternative to a local security stack at the branch, the WAN Assurance solution can use local Service Function Chaining (SFC) or secured IPsec or GRE connection to cloud providers such as Juniper Secure Edge or ZScalar. The creation of remote connections to cloud providers is fully automated and baked into WAN edge templates.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Describe how secret key material is protected throughout the entire provisioning and de-provisioning lifecycle?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) uses encrypted storage for secret keys on devices and securely distributes keys during provisioning using TLS or similar secure protocols. Key material is not exposed in plaintext, and any de-provisioned keys are invalidated immediately.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "If a unit is lost or compromised, how is key information protected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) encrypts key material stored on devices. If a unit is lost or compromised, the keys are automatically invalidated from the Mist Cloud, preventing unauthorized use. Re-provisioning requires secure re-authentication.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "What mechanisms are in place to prevent a compromised unit from gaining network access?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) uses certificate-based authentication for device access. If a unit is compromised, administrators can revoke its certificate via Mist Cloud, ensuring it cannot reconnect to the network. Additional mechanisms include AI-driven anomaly detection to flag unauthorized behavior.",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can source and destination Network Address Translation (NAT) be configured?  -(Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution meet U.S. encryption import/export guidelines and laws?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution use a single shared encryption key or multiple encryption keys between tunnels?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Are tunnel encryption keys rotated? How often are tunnel keys rotated?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) SD-WAN solutions implement automated key rotation for IPsec tunnels to enhance security. The typical rotation interval is every hour, but this can be configured based on policy.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution support latest standard for end-to-end traffic encryption? (AES- 256)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution have stateful firewalling? ",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer Deep Packet Inspection?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer an IDS & IPS feature?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer antivirus and antimalware protection?",
      Check: "No",
      Rating: 2,
      Notes: "This is currently planned for 1H25.",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Can security rules be put in place for layer 4-7?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Are application/layer 7 rules supported?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can custom applications be defined based on URL or domain and subdomain? (E.g. example.com, crm.example.com)",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Do custom applications receive 100% of the feature/functionality as built-in/system applications?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Does the solution have the ability to segment traffic?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Describe how traffic may be separated for different device types and pools?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) enables segmentation through policy-based routing and virtual routing instances (VRIs). Traffic is separated by device type or pool using granular policies defined in the Mist Cloud. This ensures logical separation of traffic for security and compliance.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "When traffic separation is in place, is a different encryption key used for VPN tunnels?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) uses separate encryption keys for each VPN tunnel, ensuring that traffic separated by virtual routing instances (VRIs) or policies is also cryptographically isolated. This enhances security for segmented traffic.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Is the network segmentation capability PCI-compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Juniper (Mist AI) supports PCI-compliant segmentation by using virtual routing instances (VRIs) and policy-based routing to isolate cardholder data environments (CDE). It adheres to the PCI DSS requirement for logical segmentation to protect sensitive data.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "How does segmentation integrate with legacy Infrastructure?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Juniper's WAN Assurance solution with the Session Smart Router (SSR) is fundamentally Zero Trust and session aware, providing stateful, directional firewall capabilities between network segments. In addition, the SSR leverages Secure Vector Routing, which uses metadata rather than tunneling to convey context across network boundaries. Metadata is a very powerful tool to provide segmentation across Networks and Applications.  Networks may be a mix of source addresses within a VLANm(most typical with 3rd party routing/switching designs), interface or global scope.  The Applications may be anywhere on the fabric and accessed using very granular segmentation policy.  The network scope is transitive across the network since this is carried in metadata, ensuring end-to-end segmentation.  The SSR can also use VRFs for routing segmentation with external legacy routers.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Does SD-WAN solution capable to secure IoT devices? Is there a need for additional hardware to secure IoT?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "DDOS Protection",
      Model: "Co-Managed/Outsourcing",
      Questions: "How is DDOS Protection Supported/Achieved",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The Session Smart Router (SSR) series platform does support distributed denial of service (DDoS) protection. The mechanism for protection against denial of service attacks (DoS Attacks) is fully compliant. Control Plane DDoS protection is enabled by default for supported protocols using firewall filters and policers to discard or rate-limit control plane traffic",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Is the device FIPS Compliant?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Are there any other Compliance Standards?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The Juniper Mist WAN Assurance solution has been validated against the following industry recognized security standards:\r\n•  FIPS 140-2, Level 1,\r\n•  NIST 800-53 Controls,\r\n•  Leveraging certified encryption module from SafeLogic,\r\n•  NIST Validated Modules certificate,\r\n•  ICSA Corporate Firewall Certification, compliance,\r\n•  Nessus/Codenomicon compliance, and\r\n•  PCI-DSS, FISMA and Penetration testing performed by DoD partners.\r\n\r\nCertificates and/or test results can be provided, if desired.",
    },
  ],
};
